// extracted by mini-css-extract-plugin
export var container = "PillGroup-module--container--4dc51";
export var label = "PillGroup-module--label--101da";
export var labelContainer = "PillGroup-module--labelContainer--e4c21";
export var pillContainer = "PillGroup-module--pillContainer--959d4";
export var priceModuleStyle = "PillGroup-module--priceModuleStyle--787cc";
export var question = "PillGroup-module--question--8831a";